import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./components/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "@amzn/meridian-tokens/base/font/amazon-ember.css";
import "@amzn/dolphin-uiweb-framework/dist/index.css";
import { HashRouter } from "react-router-dom";
import {
  DataHandler,
  RedirectHandler,
  WindowEventHandler,
  Logger,
  PUMAMetricHelper,
  MobileAnalyticsHelper,
} from "@amzn/dolphin-web-framework";
import { SoundManager } from "./audio/sound-manager";
import ErrorBoundary from "./components/error-boundary";
import DevContextProvider from "./context/dev-context";
import { KatalMonitoring, AppType, LogLevel } from '@amzn/katal-monitoring';
import { KatalMonitoringDriver } from '@amzn/katal-monitoring-aws-driver';

function playSilentSound() {
  SoundManager.playSilentSound();
  document.removeEventListener("click", playSilentSound);
}

/**
 * Playing a silent sound on first click to capture the user gesture.
 */
document.addEventListener("click", playSilentSound);

DataHandler.parseSearchParams();
RedirectHandler.clearRedirectDataFromURL();
WindowEventHandler.disableContextMenu();

//Initialise loggers and metrics
//To be changed with proper initialisation data when backend is setup
Logger.setLogger(null);
PUMAMetricHelper.pumaInit();
MobileAnalyticsHelper.initializeAnalytics();

// TODO: detailed logging and metric will be added using KatalMonitoring
const driver = new KatalMonitoringDriver({
    url: "{{KatalMonitoringUrl}}",
});

const monitor = new KatalMonitoring({
    monitoringDriver: driver,
    metricContext: {
        site: "VehicleAuditSafetyWebsite",
        serviceName: "Demo"
    },
    logThreshold: LogLevel.info,
    appType: AppType.NON_MONS
});

monitor.info("This is test log statement");
monitor.count("MySampleMetric", 1);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <HashRouter>
        {/* Declaring the DevContext here to get global access to it. */}
        <DevContextProvider>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </DevContextProvider>
    </HashRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
reportWebVitals();
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals


